var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { Button, Checkbox, Dimmer, Form, Header, Loader, Message, Modal, Table } from "semantic-ui-react";
import ErrorDisplay from "../ErrorDisplay";
import { fetchRnaCatalog, RelevantCatalogType } from "../kit/automated-pro/RnaCatalog";
import { CatalogMode, deleteWithAuthn, getWithAuthn, postJsonWithAuthn } from "../RequestHelpers";
import { displayLocalTimestamp } from "./AllOrdersPage";
var ChromogenPresetScalesPage = /** @class */ (function (_super) {
    __extends(ChromogenPresetScalesPage, _super);
    function ChromogenPresetScalesPage(props) {
        var _this = _super.call(this, props) || this;
        _this.loadCatalog = function () {
            _this.setState({ loading: true, error: false }, function () {
                Promise.all([
                    fetchRnaCatalog(CatalogMode.Internal, RelevantCatalogType.Initial),
                    getWithAuthn("/admin/chromogen/preset-scales/events")
                        .then(function (resp) { return resp.json(); })
                ])
                    .then(function (_a) {
                    var catalog = _a[0], events = _a[1];
                    _this.setState({
                        platforms: catalog.proPlatforms,
                        chromogens: catalog.proChromogens.chromogens,
                        scales: catalog.presetScales.presetProChromogenScales,
                        events: events,
                        loading: false
                    });
                })
                    .catch(function (err) {
                    console.error("Failed to load Chromogen preset scales:", err);
                    _this.setState({ loading: false, error: true });
                });
            });
        };
        _this.openAddModal = function () {
            _this.setState({
                modalOpen: true,
                editingScale: undefined,
                formState: emptyForm(),
                formErrors: [],
                formSuccess: false
            });
        };
        _this.openEditModal = function (scale) {
            _this.setState({
                modalOpen: true,
                editingScale: scale,
                formState: scaleToForm(scale),
                formErrors: [],
                formSuccess: false
            });
        };
        _this.closeModal = function () {
            _this.setState({ modalOpen: false }, _this.loadCatalog);
        };
        _this.onPlatformChange = function (_, d) {
            _this.setState(function (s) { return ({ formState: __assign(__assign({}, s.formState), { platform: d.value }) }); });
        };
        _this.onChromogenChange = function (_, d) {
            _this.setState(function (s) { return ({ formState: __assign(__assign({}, s.formState), { chromogen: d.value }) }); });
        };
        _this.onEditModesChange = function (_, d) {
            _this.setState(function (s) { return ({ formState: __assign(__assign({}, s.formState), { editModes: d.value }) }); });
        };
        _this.onInputChange = function (e) {
            var _a = e.currentTarget, name = _a.name, value = _a.value;
            _this.setState(function (s) {
                var _a;
                return ({ formState: __assign(__assign({}, s.formState), (_a = {}, _a[name] = value, _a)) });
            });
        };
        _this.onActiveChange = function (_, d) {
            _this.setState(function (s) { var _a; return ({ formState: __assign(__assign({}, s.formState), { active: (_a = d.checked) !== null && _a !== void 0 ? _a : false }) }); });
        };
        _this.onToggleInactive = function () {
            _this.setState(function (s) { return ({ showInactive: !s.showInactive }); });
        };
        _this.submitForm = function () {
            var _a = _this.state, formState = _a.formState, editingScale = _a.editingScale;
            var body = editingScale ? {
                oldUnits: editingScale.units,
                units: parseInt(formState.units, 10),
                oldUnitsLabel: editingScale.unitsLabel,
                unitsLabel: formState.unitsLabel,
                oldChromogenScaleUl: editingScale.chromogenScaleUl,
                chromogenScaleUl: parseInt(formState.chromogenScaleUl, 10),
                oldChromogenBufferScaleUl: editingScale.chromogenBufferScaleUl,
                chromogenBufferScaleUl: parseInt(formState.chromogenBufferScaleUl, 10),
                oldHemotoxylinScaleUl: editingScale.hemotoxylinScaleUl,
                hemotoxylinScaleUl: parseInt(formState.hemotoxylinScaleUl, 10),
                oldActive: editingScale.active,
                active: formState.active,
                oldEffectiveDate: editingScale.effectiveDate,
                effectiveDate: formState.effectiveDate || null,
                oldEditModes: editingScale.editModes,
                editModes: formState.editModes
            } : {
                platform: formState.platform,
                units: parseInt(formState.units, 10),
                unitsLabel: formState.unitsLabel,
                chromogen: formState.chromogen,
                chromogenScaleUl: parseInt(formState.chromogenScaleUl, 10),
                chromogenBufferScaleUl: parseInt(formState.chromogenBufferScaleUl, 10),
                hemotoxylinScaleUl: parseInt(formState.hemotoxylinScaleUl, 10),
                active: formState.active,
                effectiveDate: formState.effectiveDate || null,
                editModes: formState.editModes
            };
            var path = editingScale
                ? "/admin/chromogen/preset-scales/update/" + editingScale.id
                : "/admin/chromogen/preset-scales/add";
            _this.setState({ formLoading: true, formErrors: [], formSuccess: false }, function () {
                postJsonWithAuthn(path, JSON.stringify(body))
                    .then(function (resp) {
                    if (resp.ok) {
                        _this.setState({ formLoading: false, formSuccess: true });
                    }
                    else if (resp.status === 400) {
                        return resp.json().then(function (err) {
                            _this.setState({ formLoading: false, formErrors: err.errors });
                        });
                    }
                    else {
                        _this.setState({
                            formLoading: false,
                            formErrors: [{ path: "/", msg: "An unexpected error occurred" }]
                        });
                    }
                    return undefined;
                })
                    .catch(function (err) { return console.error("Failed to save Chromogen preset scale:", err); });
            });
        };
        _this.addPresets = function () {
            if (!window.confirm("Add preset scales for Leica, Oncore Pro X, and Manual?")) {
                return;
            }
            _this.setState({ bulkAdding: true }, function () {
                postJsonWithAuthn("/admin/chromogen/preset-scales/add-presets", JSON.stringify({}))
                    .then(function () { return _this.setState({ bulkAdding: false }, _this.loadCatalog); })
                    .catch(function (err) {
                    console.error("Failed to add presets:", err);
                    _this.setState({ bulkAdding: false });
                });
            });
        };
        _this.deleteScale = function (id) {
            if (!window.confirm("Delete scale #" + id + "?")) {
                return;
            }
            deleteWithAuthn("/admin/chromogen/preset-scales/" + id)
                .then(function (resp) {
                if (resp.ok) {
                    return _this.loadCatalog();
                }
                else if (resp.status === 400) {
                    return resp.json().then(function (errorResp) {
                        window.alert(errorResp.errors.map(function (e) { return e.msg; }).join("\n"));
                    });
                }
                else {
                    window.alert("An unexpected error occurred");
                }
                return undefined;
            })
                .catch(function (err) { return console.error("Failed to delete Chromogen preset scale:", err); });
        };
        _this.state = {
            loading: false,
            error: false,
            platforms: [],
            chromogens: [],
            modalOpen: false,
            formState: emptyForm(),
            formLoading: false,
            formErrors: [],
            formSuccess: false,
            showInactive: false,
            events: undefined,
            bulkAdding: false
        };
        return _this;
    }
    ChromogenPresetScalesPage.prototype.componentDidMount = function () {
        this.loadCatalog();
    };
    ChromogenPresetScalesPage.prototype.render = function () {
        var _this = this;
        var _a = this.state, loading = _a.loading, error = _a.error, scales = _a.scales, events = _a.events, platforms = _a.platforms, chromogens = _a.chromogens, modalOpen = _a.modalOpen, formState = _a.formState, formLoading = _a.formLoading, formErrors = _a.formErrors, formSuccess = _a.formSuccess, editingScale = _a.editingScale, showInactive = _a.showInactive, bulkAdding = _a.bulkAdding;
        var visibleScales = scales === null || scales === void 0 ? void 0 : scales.filter(function (s) { return showInactive || s.active; });
        var platformOptions = platforms.map(function (p) { return ({ key: p.id, text: p.alias, value: p.id }); });
        var chromogenOptions = chromogens.map(function (c) { return ({ key: c.id, text: c.label, value: c.id }); });
        return (React.createElement("div", { style: { maxWidth: "1400px", margin: "0 auto", padding: "1rem" } },
            React.createElement("h2", null, "Chromogen Preset Scales"),
            React.createElement(Message, { info: true, style: { marginBottom: "1.5rem" } },
                React.createElement(Message.Header, null, "How this page works"),
                React.createElement("p", { style: { marginTop: "0.75rem" } }, "Chromogen preset scales are keyed by platform, units and chromogen. Active scales and scheduled effective dates are unique per platform, units and chromogen.")),
            React.createElement(Dimmer.Dimmable, null,
                React.createElement(Dimmer, { active: loading, inverted: true },
                    React.createElement(Loader, null)),
                error && React.createElement(Message, { negative: true }, "Failed to load Chromogen preset scales."),
                visibleScales && (React.createElement(React.Fragment, null,
                    React.createElement("div", { style: { marginBottom: "1rem", display: "flex", alignItems: "center", gap: "0.75rem" } },
                        React.createElement(Button, { icon: "plus", labelPosition: "left", label: "Add Scale", onClick: this.openAddModal }),
                        React.createElement(Button, { loading: bulkAdding, disabled: bulkAdding, onClick: this.addPresets }, "Add Preset Scales"),
                        React.createElement(Checkbox, { toggle: true, label: "Show inactive", checked: showInactive, onChange: this.onToggleInactive })),
                    React.createElement(Table, { striped: true, celled: true, compact: true },
                        React.createElement(Table.Header, null,
                            React.createElement(Table.Row, null,
                                React.createElement(Table.HeaderCell, null, "ID"),
                                React.createElement(Table.HeaderCell, null, "Platform"),
                                React.createElement(Table.HeaderCell, null, "Units"),
                                React.createElement(Table.HeaderCell, null, "Units Label"),
                                React.createElement(Table.HeaderCell, null, "Chromogen"),
                                React.createElement(Table.HeaderCell, null, "Chromogen Scale (uL)"),
                                React.createElement(Table.HeaderCell, null, "Chromogen Buffer Scale (uL)"),
                                React.createElement(Table.HeaderCell, null, "Hemotoxylin Scale (uL)"),
                                React.createElement(Table.HeaderCell, null, "Active"),
                                React.createElement(Table.HeaderCell, null, "Effective Date"),
                                React.createElement(Table.HeaderCell, null, "Edit Modes"),
                                React.createElement(Table.HeaderCell, null, "Actions"))),
                        React.createElement(Table.Body, null, visibleScales.slice().sort(function (a, b) { return a.id - b.id; }).map(function (scale) { return (React.createElement(ScaleRow, { key: scale.id, scale: scale, onEdit: _this.openEditModal, onDelete: _this.deleteScale })); })))))),
            events && presetScaleEventsTable(events),
            React.createElement(Modal, { open: modalOpen, onClose: this.closeModal, closeIcon: true },
                React.createElement(Modal.Header, null, editingScale ? "Edit Scale #" + editingScale.id : "Add Chromogen Preset Scale"),
                React.createElement(Modal.Content, null,
                    React.createElement(Dimmer.Dimmable, { as: Form, error: formErrors.length > 0 },
                        React.createElement(Dimmer, { active: formLoading, inverted: true },
                            React.createElement(Loader, null)),
                        formSuccess && React.createElement(Message, { positive: true }, "Saved successfully."),
                        React.createElement(ErrorDisplay, { errors: formErrors, errorPath: "/" }),
                        React.createElement(Form.Select, { label: "Platform", options: platformOptions, value: formState.platform, onChange: this.onPlatformChange, disabled: !!editingScale }),
                        React.createElement(Form.Input, { label: "Units", type: "number", name: "units", value: formState.units, onChange: this.onInputChange }),
                        React.createElement(Form.Input, { label: "Units Label", type: "text", name: "unitsLabel", value: formState.unitsLabel, onChange: this.onInputChange }),
                        React.createElement(Form.Select, { label: "Chromogen", options: chromogenOptions, value: formState.chromogen, onChange: this.onChromogenChange, disabled: !!editingScale }),
                        React.createElement(Form.Input, { label: "Chromogen Scale (uL)", type: "number", name: "chromogenScaleUl", value: formState.chromogenScaleUl, onChange: this.onInputChange }),
                        React.createElement(Form.Input, { label: "Chromogen Buffer Scale (uL)", type: "number", name: "chromogenBufferScaleUl", value: formState.chromogenBufferScaleUl, onChange: this.onInputChange }),
                        React.createElement(Form.Input, { label: "Hemotoxylin Scale (uL)", type: "number", name: "hemotoxylinScaleUl", value: formState.hemotoxylinScaleUl, onChange: this.onInputChange }),
                        React.createElement(Form.Select, { label: "Edit Modes", options: editModeOptions, value: formState.editModes, onChange: this.onEditModesChange, multiple: true }),
                        React.createElement(Form.Field, null,
                            React.createElement(Checkbox, { label: "Active", checked: formState.active, onChange: this.onActiveChange })),
                        React.createElement(Form.Field, null,
                            React.createElement("label", null, "Effective Date (optional)"),
                            React.createElement("input", { type: "date", name: "effectiveDate", value: formState.effectiveDate, onChange: this.onInputChange }),
                            React.createElement("div", { style: { marginTop: "0.5rem", fontSize: "0.85em", color: "#666" } }, "Dates are relative to the Los Angeles timezone")),
                        React.createElement(Button, { primary: true, onClick: this.submitForm }, editingScale ? "Update" : "Add"),
                        React.createElement(Button, { onClick: this.closeModal }, "Cancel"))))));
    };
    return ChromogenPresetScalesPage;
}(React.Component));
export default ChromogenPresetScalesPage;
var ScaleRow = /** @class */ (function (_super) {
    __extends(ScaleRow, _super);
    function ScaleRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleEdit = function () { return _this.props.onEdit(_this.props.scale); };
        _this.handleDelete = function () { return _this.props.onDelete(_this.props.scale.id); };
        return _this;
    }
    ScaleRow.prototype.render = function () {
        var _a;
        var scale = this.props.scale;
        return (React.createElement(Table.Row, null,
            React.createElement(Table.Cell, null, scale.id),
            React.createElement(Table.Cell, null, scale.platform.label),
            React.createElement(Table.Cell, null, scale.units),
            React.createElement(Table.Cell, null, scale.unitsLabel),
            React.createElement(Table.Cell, null, scale.chromogen.label),
            React.createElement(Table.Cell, null, scale.chromogenScaleUl),
            React.createElement(Table.Cell, null, scale.chromogenBufferScaleUl),
            React.createElement(Table.Cell, null, scale.hemotoxylinScaleUl),
            React.createElement(Table.Cell, null, scale.active ? "Yes" : "No"),
            React.createElement(Table.Cell, null, (_a = scale.effectiveDate) !== null && _a !== void 0 ? _a : "-"),
            React.createElement(Table.Cell, null, scale.editModes.join(", ")),
            React.createElement(Table.Cell, null,
                React.createElement(Button, { size: "tiny", icon: "edit", onClick: this.handleEdit }),
                React.createElement(Button, { size: "tiny", icon: "trash", negative: true, onClick: this.handleDelete }))));
    };
    return ScaleRow;
}(React.PureComponent));
var editModeOptions = [
    { key: "CONSUMER", text: "CONSUMER", value: "CONSUMER" },
    { key: "ADMIN", text: "ADMIN", value: "ADMIN" }
];
var emptyForm = function () { return ({
    platform: "",
    units: "",
    unitsLabel: "",
    chromogen: "",
    chromogenScaleUl: "",
    chromogenBufferScaleUl: "",
    hemotoxylinScaleUl: "",
    active: false,
    effectiveDate: "",
    editModes: []
}); };
var scaleToForm = function (scale) {
    var _a;
    return ({
        platform: scale.platform.id,
        units: String(scale.units),
        unitsLabel: scale.unitsLabel,
        chromogen: scale.chromogen.id,
        chromogenScaleUl: String(scale.chromogenScaleUl),
        chromogenBufferScaleUl: String(scale.chromogenBufferScaleUl),
        hemotoxylinScaleUl: String(scale.hemotoxylinScaleUl),
        active: scale.active,
        effectiveDate: (_a = scale.effectiveDate) !== null && _a !== void 0 ? _a : "",
        editModes: scale.editModes
    });
};
export function presetScaleEventsTable(events) {
    return React.createElement(React.Fragment, null,
        React.createElement(Header, null, "Event Log"),
        React.createElement(ReactTable, { columns: [
                { id: "id", Header: "ID", accessor: function (e) { return e.id; }, width: 70 },
                { id: "userName", Header: "User", accessor: function (e) { return e.userName; } },
                { id: "eventType", Header: "Type", accessor: function (e) { return e.eventType; } },
                {
                    id: "eventMsg",
                    Header: "Message",
                    accessor: function (e) { return e.eventMsg; },
                    Cell: function (props) { return React.createElement("span", { title: props.value }, props.value); }
                },
                {
                    id: "createdAt",
                    Header: "Created",
                    accessor: function (e) { return displayLocalTimestamp(e.createdAt); }
                }
            ], data: events, defaultPageSize: 50, defaultSorted: [{ id: "createdAt", desc: true }], minRows: 1 }));
}
//# sourceMappingURL=ChromogenPresetScalesPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/ChromogenPresetScalesPage.js
// module id = 228
// module chunks = 0